<template>
    <LockDesignerPanel @update-route="handleUpdateRoute" @update-selection="handleUpdateSelection"></LockDesignerPanel>
</template>
<script lang="ts">
import LockDesignerPanel from 'Vue/components/lockDesigner/components/LockDesignerPanel.vue';
import { mapGetters, mapActions } from 'vuex'; // Import useStore from vuex

export default {
    name: 'LockDesignerDoorType',
    components: {
        LockDesignerPanel,
    },
    computed: {
        ...mapActions(['fetchDoorType', 'updateDoorTypeSelections']),
        ...mapGetters(['componentGroups', 'resetComponentGroups', 'isLoadingDefault']),
        doorTypeOption: function () {
            return this.$route.params?.option || 'DoorType';
        },
    },

    emits: ['update-route', 'update-selection'],
    methods: {
        handleUpdateRoute(route: any) {
            this.$emit('update-route', route);
        },
        async handleUpdateSelection(selection: any) {
            await this.$store.dispatch('updateDoorTypeSelections', { doorTypeOption: this.doorTypeOption, ...selection });
        },
        async handleFetchPageData() {
            await this.$store.dispatch('fetchDoorType', { doorTypeOption: this.doorTypeOption });
        },
    },
    mounted() {
        if (!this.isLoadingDefault) {
            this.handleFetchPageData();
        }
    },
    async unmounted() {
        await this.$store.dispatch('resetComponentGroups');
    },
};
</script>
